import { KeyValueDefault } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { AxiosResponse } from "axios";

export abstract class IIntegrationTriggerApi {
	abstract getDomain(): Promise<AxiosResponse<Result<KeyValueDefault[]>>>;
}
